import {
    GET_POSITIONS,
    GET_POSITION_GROUPS,
	ADD_POSITION,
	DELETE_POSITION,
	UPDATE_POSITION
} from '../../Actions/Admin/ManagePositionActions';

const initialState = {
	positions: [],
    positionGroups: []
};
export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_POSITIONS:
			return {
				...state,
				positions: action.payload
			};
		case GET_POSITION_GROUPS:
			return {
				...state,
				positionGroups: action.payload
			};
		case ADD_POSITION:
			return {
				...state,
				positions: action.payload
			};
		case DELETE_POSITION:
			return {
				...state,
				positions: action.payload
            };
        case UPDATE_POSITION:
			return {
				...state,
				positions: action.payload
			};
		default:
			return state;
	}
};
